<template>
  <div>
    <div class="modal fade agenda__add-to-calendar" :data-modal-key="modalKey" id="add-to-calendar-modal" tabindex="-1" aria-labelledby="add-to-calendar-modal-title" aria-hidden="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title text-center w-100" id="add-to-calendar-modal-title">{{modalTitle || lang.get('event_strings.agenda.add_to_calendar')}}</h2>
            <button type="button" class="close textColor" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="loaded">
            <a :href="iCalendarInviteUrl" class="agenda-calendar-invite ical-invite" target="_blank" download="cal.ics" aria-label="Add to Apple Calendar">
              <span class="ical-invite-logo icon icon-apple"></span>
              {{lang ? lang.get('event_strings.agenda.add_to_apple_calendar') : ""}}
              <span class="invite-carat">
              <i class="fas fa-chevron-right"></i>
              </span>
            </a>
            <a :href="outlookCalendarInviteUrl" class="agenda-calendar-invite outlook-invite" target="_blank"  download="cal.ics" aria-label="Add to Outlook Calendar">
              <span class="outlook-invite-logo icon icon-outlook"></span>
              {{lang ? lang.get('event_strings.agenda.add_to_outlook_calendar') : ""}}
              <span class="invite-carat">
              <i class="fas fa-chevron-right"></i>
              </span>
            </a>
            <a :href="googleCalendarInvite" class="agenda-calendar-invite google-invite"  target="_blank" aria-label="Add to Google Calendar">
              <span class="google-invite-logo icon icon-google"></span>
              {{lang ? lang.get('event_strings.agenda.add_to_google_calendar') : ""}}
              <span class="invite-carat">
              <i class="fas fa-chevron-right"></i>
              </span>
            </a>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        appleCalendarInvite: '#',
        outlookCalendarInvite: '#',
        googleCalendarInvite: '#',
        appleCalendarInviteUrl: '#',
        outlookInviteUrl: '#',
        agendaItem: null,
        event: null,
        loaded: false,
      }
    },
    props: {
      modalTitle: {
        type: String,
        default: ""
      },
      modalKey: {
        type: [String, Number],
        default: 1
      },
      downloadFromServer: {
        type: Boolean,
        default: false
      },
      agendaPluginId: {
        default: null
      }
    },
    computed: {
      modalSelector() {
        return `#add-to-calendar-modal[data-modal-key='${this.modalKey}']`;
      },
      modalOpenEventName() {
        return `openAddToCalendarModal-${this.modalKey}`;
      },
      modalCloseEventName() {
        return `closeAddToCalendarModal-${this.modalKey}`;
      },
      iCalendarInviteUrl () {
        if (this.downloadFromServer) return this.appleCalendarInviteUrl
        return this.appleCalendarInvite
      },

      outlookCalendarInviteUrl () {
        if (this.downloadFromServer) return this.outlookInviteUrl
        return this.outlookCalendarInvite
      }
    },
    methods: {
      generateCalendarInvite: function(agendaItem){
        var self = this;
        var isLocalizedAgenda = this.event.enable_local_agenda_timezone
        var currentAttendeeTimezone;

        if (window.currentEventAttendee && window.currentEventAttendee.attendee_fields && window.currentEventAttendee.attendee_fields.timezone) {
          currentAttendeeTimezone = window.currentEventAttendee.attendee_fields.timezone;
        }
        else {
          currentAttendeeTimezone = moment.tz.guess();
        }

        var date = agendaItem.scheduled_date.replace(/\-/g,'');
        var startTime = agendaItem.start_datetime.replace(/\ /g,'T').replace(/\:/g,'').replace(/\-/g,'');
        var endTime = ''
        if (agendaItem.end_datetime) {
            endTime = agendaItem.end_datetime.replace(/\ /g,'T').replace(/\:/g,'').replace(/\-/g,'');
        }

        // If agenda is grouped by start time, grab the unformatted start time
        // if(self.event.agenda_group_by_start_time){
        //     startTime = agendaItem.unformatted_start_time.replace(/\:/g,'');
        // }

        // Use desc which has been stripped of tags, css, excess spaces, and commented out code
        var strippedDescription = agendaItem.description_stripped ? agendaItem.description_stripped : '';
        if(!agendaItem.description_stripped){
            strippedDescription = agendaItem.description ? agendaItem.description.replace(/(<([^>]+)>)/gi, "") : '';
        }

        let locations = []
        let AchatRooms = Object.assign({}, agendaItem.chatRooms);
        if(agendaItem.chatRooms && agendaItem.chatRooms.length != 0 ){
            locations = Array.prototype.map.call(AchatRooms, function(item) { if(!item.url.match(/^(http(s)?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/)){ item.url = location.host + item.url; } return item.url; }).join(" / ");                    
        }else{
            if(agendaItem.locations && agendaItem.locations.length != 0){
                locations = Array.prototype.map.call(agendaItem.locations, function(item) { if(item.custom_chat_url && !item.custom_chat_url.match(/^(http(s)?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/)){ item.custom_chat_url = location.host + item.custom_chat_url; } return (!item.custom_chat_url)?item.name:item.custom_chat_url; }).join(" / ");
            }
        }
        let baseUrl = 'https://' + document.location.host + "/schedule";

        if (agendaItem.detail_page) {
          var agendaLink =  `${baseUrl}/${agendaItem.id}/detail`;
        } else if (this.agendaPluginId) {
          var agendaLink = `${baseUrl}/${this.agendaPluginId}?activeDay=${agendaItem.scheduled_date}`
        } else {
          var agendaLink = `${baseUrl}?activeDay=${agendaItem.scheduled_date}`
        }
        var invite = {
            startTime: startTime,
            endTime: endTime,
            url: document.location.host,
            title: agendaItem.name + " (" + self.event.name + ")",
            desc: strippedDescription.replace(/&mdash;/g, "-").replace(/&ldash;/g, "-").replace(/&ndash;/g, "-"),
            locations: agendaLink,
        };
        
        var ical = 
            'data:text/calendar;charset=utf8,' + [
              'BEGIN:VCALENDAR',
              'VERSION:2.0',
              'PRODID:-//Eventfinity//NONSGML v1.0//EN',
              'BEGIN:VTIMEZONE',
              'TZID:' + self.event.timezone,
              'END:VTIMEZONE',
              'BEGIN:VEVENT',
              'CONTACT:' + encodeURIComponent(invite.title),
              'URL:' + invite.url,
              'DTSTART;TZID=' + (isLocalizedAgenda ? currentAttendeeTimezone : self.event.timezone ) + ':' + invite.startTime,
              'DTEND;TZID=' + (isLocalizedAgenda ? currentAttendeeTimezone : self.event.timezone ) + ':' + invite.endTime,
              'SUMMARY:' + encodeURIComponent(invite.title),
              'DESCRIPTION:' + encodeURIComponent(invite.desc),
              'LOCATION:' + encodeURIComponent(invite.locations),
              'END:VEVENT',
              'END:VCALENDAR'].join(encodeURIComponent('\r\n'));

        this.appleCalendarInvite = ical;
        this.appleCalendarInviteUrl = `/schedule-items/${agendaItem.id}/icalendar-ics`

        var outlook = 
        'data:text/calendar;charset=utf8,' + [
            'BEGIN:VCALENDAR',
            'PRODID:-/Microsoft Corporation//Outlook 11.0 MIMEDIR//EN',
            'VERSION:2.0',
            'METHOD:PUBLISH'].join(encodeURIComponent('\n'))
            + encodeURIComponent('\n')
            + agendaItem.outlookCalTz.join(encodeURIComponent('\n')) 
            + encodeURIComponent('\n') 
            + ['BEGIN:VEVENT',
            'URL:' + invite.url,
            'DTSTART:' + agendaItem.outlookStart,
            'DTEND:' + agendaItem.outlookEnd,
            'SUMMARY:' + encodeURIComponent(invite.title),
            'DESCRIPTION:' + encodeURIComponent(invite.desc),
            'LOCATION:' + encodeURIComponent(invite.locations),
            'END:VEVENT',
            'END:VCALENDAR'].join(encodeURIComponent('\n'));

        this.outlookCalendarInvite = outlook;
        this.outlookInviteUrl = `/schedule-items/${agendaItem.id}/outlook-ics`
            
        var google = 'https://calendar.google.com/calendar/render?action=TEMPLATE' 
            + '&text=' + encodeURIComponent(invite.title) 
            + '&dates=' + invite.startTime + '/' + invite.endTime
            + '&ctz=' + (isLocalizedAgenda ? currentAttendeeTimezone : this.event.timezone )
            + '&details=' + encodeURIComponent(invite.desc) + '%0A%0A' + invite.url 
            + '&sf=true';
        if(invite.locations.length > 0){
            google = google + '&location=' + encodeURIComponent(invite.locations);
        }
        this.googleCalendarInvite = google;
      },
      handleOpen({agendaItem, event, eventAttendeeFields}){
        this.agendaItem = agendaItem;
        this.event= event;
        this.eventAttendeeFields = eventAttendeeFields;
        this.generateCalendarInvite(agendaItem);
        $(this.modalSelector).modal('show');
      },
      handleClose(){
        $(this.modalSelector).modal('hide');
      },
      reset(){
        this.agendaItem = null;
        this.event= null;
        this.eventAttendeeFields = null;
        this.appleCalendarInvite = "#";
        this.outlookCalendarInvite = "#";
        this.googleCalendarInvite = "#";
      }
    },
    mounted(){
      let self = this;
      this.loaded = true;
      EventBus.$on(this.modalOpenEventName, (data) => {
        self.$emit('input',true)
        self.handleOpen(data);
      });
      EventBus.$on(this.modalCloseEventName, (data) => {
        self.handleClose();
      });
      $(this.modalSelector).on('hidden.bs.modal', function (e) {
        self.reset();
      })
    },
    beforeDestroy(){
      EventBus.$off(this.modalOpenEventName);
      EventBus.$off(this.modalCloseEventName);
      $(this.modalSelector).off('hidden.bs.modal');
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>

</style>